import TokenAllocation from './TokenAllocation';
import { tokenAllocations } from '../../data/tokenomics';

export default function TokenDistribution() {
  return (
    <div className="bg-white rounded-xl shadow-lg p-8 mb-16">
      <h2 className="text-primary mb-6 text-center">Token Distribution</h2>
      <div className="space-y-8">
        {tokenAllocations.map((allocation, index) => (
          <TokenAllocation key={index} allocation={allocation} />
        ))}
      </div>
    </div>
  );
}